import get from 'lodash/get'

export const getShowMessage = (state) => get(state, ['ui', 'snackbar', 'show']);
export const getMessage = (state) => get(state, ['ui', 'snackbar', 'message']);



// WEBPACK FOOTER //
// ./src/selectors/snackbar.js